import React, { createContext, ReactNode, useContext } from 'react';
import { SelectedPreviewActor } from '@avatar/hooks/useSelectedPreviewActor';
import { FALLBACK_AVATAR } from '@avatar/constants';
/*
 * For use in teleporting the script studio preview avatar prop
 */
const PreviewAvatarContext = createContext<SelectedPreviewActor | undefined>(
  undefined
);

export const usePreviewAvatarContext = () => {
  return useContext(PreviewAvatarContext);
};

interface PreviewAvatarProviderProps {
  children: ReactNode;
  previewAvatar: SelectedPreviewActor | null;
}

const PreviewAvatarProvider = (props: PreviewAvatarProviderProps) => {
  const { children, previewAvatar } = props;
  return (
    <PreviewAvatarContext.Provider value={previewAvatar ?? FALLBACK_AVATAR}>
      {children}
    </PreviewAvatarContext.Provider>
  );
};

export default PreviewAvatarProvider;
